<template>
  <div class="list-container">
    <section class="list-wrapper d-flex" style="overflow: auto">
      <div style="flex: 1; height: 100%" class="list-group">
        <button
          v-for="role in rolesList"
          :key="role.name"
          class="list-group-item d-flex align-items-center p-3 border"
          style="gap: 12px"
          :style="{
            backgroundColor: hoveredRole === role.name ? '#ebf0f2' : 'white',
          }"
          @click="handleSelectRoleReactive(role)"
          @mouseover="handleMouseoverRole(role.name)"
          @focus="handleMouseoverRole(role.name)"
        >
          <FancyRadioIcon :is-active="selectedRoleReactive === role.name" />
          <span v-if="$te('users.roles.id_' + role.id)">
            {{ $t("users.roles.id_" + role.id) }}
          </span>
          <span v-else>{{ role.display_name }}</span>
        </button>
      </div>
      <div style="flex: 1; overflow: auto" class="p-3 role-box">
        <article>
          <h4 class="mt-0 mb-3">
            {{ $t("users.roleDetail") }}
            {{ $t("users.roles.id_" + getHoverRoleId()) }}
          </h4>
          <RoleFeatureGroup
            v-for="group in featuresList"
            :key="group.name"
            :title="$t('permission.bpz.' + group.name)"
            :features="group.features"
            :permissionsList="permissionsList[hoveredRole]"
          />
        </article>
      </div>
    </section>
  </div>
</template>

<script>
import FancyRadioIcon from "../../components/ui/FancyRadioIcon.vue";
import RoleFeature from "../../components/ui/role/feature.vue";
import RoleFeatureGroup from "../../components/ui/role/featureGroup.vue";
import permissionsList from "./beepiz-permissions.js";
import featuresList from "./beepiz-features.js";

export default {
  name: "RolesBeepizList",
  components: {
    FancyRadioIcon,
    RoleFeature,
    RoleFeatureGroup,
  },
  props: {
    selectedRole: {
      type: Object,
      default: null,
    },
    rolesList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      selectedRoleReactive: this.selectedRole ? this.selectedRole.name : null,
      hoveredRole: this.selectedRole
        ? this.selectedRole.name
        : this.rolesList[0].name,
    };
  },
  watch: {
    selectedRole: {
      immediate: true,
      handler(val) {
        this.selectedRoleReactive = val ? val.name : null;
        this.hoveredRole = val ? val.name : this.rolesList[0].name;
      },
    },
    rolesList: {
      immediate: true,
      handler(val) {
        this.hoveredRole = this.selectedRole
          ? this.selectedRole.name
          : val[0].name;
      },
    },
  },
  methods: {
    handleSelectRoleReactive(role) {
      this.selectedRoleReactive = role.name;
      const selectedRole = this.rolesList.find(
        (role) => role.name === this.selectedRoleReactive
      );
      this.$emit("handleSelectRole", selectedRole);
    },
    handleMouseoverRole(roleName) {
      this.hoveredRole = roleName;
    },
    getHoverRoleId() {
      if (this.rolesList.length === 0) return null;
      const role = this.rolesList.find(
        (role) => role.name === this.hoveredRole
      );
      return role ? role.id : this.rolesList[0].id;
    },
  },
  computed: {
    permissionsList() {
      return permissionsList;
    },
    featuresList() {
      return featuresList;
    },
  },
};
</script>

<style lang="scss" scoped>
.list-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.list-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
  @media (min-width: 768px) {
    min-width: 80vw;
  }
}
.list-group {
  border: 1px solid #d1d5db;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
}
.list-group-item {
  flex: 1;
  cursor: pointer;
  border: none;
  border-radius: 0;
  text-align: left;
  // position: relative;
}
.list-group-item:focus-visible {
  z-index: 1;
}
.list-group-item:not(:last-child) {
  border-bottom: 1px solid #d1d5db;
}
.role-box {
  border: 1px solid #d1d5db;
  height: 100%;
  position: relative;
  margin-left: -1px;
  h4 {
    font-size: 1.125rem;
    font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/roles/beepiz-list.vue